import { ApiService } from "./apiService";

export const PressReviewService =()=> {

    return {
        getReviews:async()=>{
            const response = await ApiService.get('/api/items/press_review?fields=title,source,image.width,image.height,image.id&filter[status][_eq]=published');
            return response.data;
        }
    }
}
